<template>
  <div>
    <demandeEntete
      :demandeur="demandeur"
      :typeDemande="typeDemande"
      :codeTypeDemande="codeTypeDemande"
      :dateCreation="dateCreation"
      :commentaire="commentaire"
      :complements="complements"
      :motifRefus="motifRefus"
    />

    <viewPersonneMorale
      ref="view"
      :dsType="dsType"
      :filiales="filiales"
      :divisions="divisions"
      :contacts="contacts"
      :form="form"
      :control="control"
      :enums="enums"
      :analyseDiff="analyseDiff"
      @annulerSuppression="annulerSuppression($event)"
    >
    </viewPersonneMorale>

    <entiteModificationModal />

    <demandeAction />
  </div>
</template>

<script>
import moment from 'moment';
import ViewPersonneMorale from '@/view/personnemorale/ViewPersonneMorale';
import { nettoyageTelephone } from '@/view/personnemorale/personnemoraleUtils';
import DemandeEntete from '@/components/workflow/DemandeEntete';
import DemandeAction from '@/components/workflow/DemandeAction';
import EditeurDemande from '@/plugins/mixins/EditeurDemande';
import { routeEnter } from '@/utils/entite';
import toasted from '@/utils/toasted';

export default {
  components: {
    viewPersonneMorale: ViewPersonneMorale,
    demandeEntete: DemandeEntete,
    demandeAction: DemandeAction,
  },
  mixins: [EditeurDemande],
  beforeRouteEnter: routeEnter(withId => {
    withId(
      id => `workflow/demande/${id}`,
      (vm, body) => {
        vm.initForm(body);
      },
    );
  }),
  data() {
    return {
      dsType: null,

      enums: {
        contextes: [],
        cotiseA: [],
        types: [],
      },
      motifRefus: null,
      form: {
        id: null,
        nomUsuel: null,
        raisonSociale: null,
        sirenOuSiret: null,
        type: {
          id: null,
          libelle: null,
        },
        mail: null,
        fax: null,
        domicilieeMDL: false,
        organisationPro: false,
        siteInternet: null,

        // Collections
        adresses: null,
        telephones: null,
        maisonsMeres: [],
        contextes: [],
        cotiseA: [],

        // RGPD
        dateCreation: null,
        chargeCreation: null,
        dateModification: null,
        chargeModification: null,
        demandeurCreation: null,
      },
      filiales: null,
      divisions: [],
      contacts: null,
    };
  },

  methods: {
    initForm(data) {
      this.initEditeurDemande(data);

      //injection du droit d'edition
      this.control.edition = 'AUCUN';

      //chargement du diff
      this.typeDemande = data.demandeType.libelle;
      this.demandeur = data.demandeurCreation;
      this.commentaire = data.commentaire;
      this.dateCreation = moment(data.dateCreation).format(
        'DD/MM/YYYY [à] HH:mm',
      );

      const loaded = data.objet;
      this.form.dateCreation = loaded.dateCreation;
      this.form.chargeCreation = loaded.chargeCreation;
      this.form.dateModification = loaded.dateModification;
      this.form.demandeurCreation = loaded.demandeurCreation;
      this.form.chargeModification = loaded.chargeModification;

      this.form.nomUsuel = loaded.nomUsuel;
      this.form.raisonSociale = loaded.raisonSociale;
      this.form.sirenOuSiret = loaded.sirenOuSiret;
      this.form.mail = loaded.mail;
      this.form.fax = loaded.fax;
      this.form.domicilieeMDL = loaded.domicilieeMDL;
      this.form.organisationPro = loaded.organisationPro;
      this.form.fax = loaded.fax;
      this.form.type.id = loaded.type ? loaded.type.id : null;
      this.form.type.libelle = loaded.type ? loaded.type.libelle : null;
      this.form.siteInternet = loaded.siteInternet;
      this.form.adresses = [...loaded.adresses];
      this.form.telephones = [...loaded.telephones];
      this.form.maisonsMeres = [...loaded.maisonsMeres];
      this.form.contextes = [...loaded.contextes];
      this.form.cotiseA = [...loaded.cotiseA];
      this.filiales = [...loaded.filiales];
      this.divisions = [...loaded.divisions];
      this.contacts = [...loaded.contacts];

      this.sortPersonnesMorales(this.filiales);
      this.sortPersonnesMorales(this.maisonsMeres);

      if (data.enums) {
        this.initEnums(data.enums);
      }

      this.__initEdition();
    },
    sortPersonnesMorales(data) {
      if (Array.isArray(data)) {
        data.sort((a, b) => {
          return a.nomUsuel.localeCompare(b.nomUsuel, 'fr', {
            sensitivity: 'base',
            ignorePunctuation: true,
          });
        });
      }
    },
    getForms() {
      //access aux formulaire à créer
      return this.$refs.view.getForms();
    },

    validerDemande() {
      const id = this.idDemande;
      var data = null;
      var url = null;
      if ('modification' === this.codeTypeDemande) {
        if (!this.__valider()) {
          this.control.dialogValider = false;
          return;
        }

        url = `workflow/demande/modification/${id}/personne-morale/valider`;

        //filtre en supprimant tous les champs supprimés
        data = nettoyageTelephone(this.form);
        data.maisonsMeres = data.maisonsMeres.filter(
          this.creationFiltreSupprimes('maisonMeres'),
        );
        data.telephones = data.telephones.filter(
          this.creationFiltreSupprimes('telephones', true),
        );
        data.adresses = data.adresses.filter(
          this.creationFiltreSupprimes('adresses', true),
        );
        data.contextes = data.contextes.filter(
          this.creationFiltreSupprimes('contextes'),
        );
        data.cotiseA = data.cotiseA.filter(
          this.creationFiltreSupprimes('cotiseA'),
        );
      } else if ('suppression' === this.codeTypeDemande) {
        url = `workflow/demande/suppression/${id}/personne-morale/valider`;
      } else if ('creation' === this.codeTypeDemande) {
        if (!this.__valider()) {
          this.control.dialogValider = false;
          return;
        }

        url = `workflow/demande/creation/${id}/personne-morale/valider`;
        data = nettoyageTelephone(this.form);
      }

      this.control.validerDemande = true;
      this.$api(url)
        .post(data)
        .then(() => {
          toasted.info('demande.status.valide');
          this.__annuler(false);
          this.$router.push({ name: 'workflow/demande' });
        })
        .catch(errors => {
          this.control.dialogValider = false;
          this.errorsHandler(errors);
        })
        .finally(() => (this.control.validerDemande = false));
    },

    initEnums(body) {
      const enums = this.enums;
      enums.contextes = body.contextes;
      enums.cotiseA = body.cotiseA;
      enums.types = body.types;
    },
  },
};
</script>
